import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { SmallLoading } from '@components/loading';
import { scale } from '@components/frame';
import i18n from 'i18n-js';
import { isPhone } from '@helpers';
import Button from '@styles/buttons';
import { font } from '@styles/fonts';
import { SettingsHeaderProps } from '@components/settings/v2/common/SettingsHeader';

interface HeaderActionButtonProps extends Pick<SettingsHeaderProps, 'C' | 'actionLoading' | 'actionConfig' | 'action' | 'name'> {}

const HeaderActionButton: FC<HeaderActionButtonProps> = ({ C, actionLoading, action, actionConfig, name }) => {
  if (actionLoading) {
    return (
      <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginRight: scale(18) }}>
        <SmallLoading />
      </View>
    );
  }

  const tabMapping = {
    MachineConnection: i18n.t('Save'),
    AccountDetails: i18n.t('Edit'),
    Users: i18n.t('Invite'),
    MachinesGroupDetails: i18n.t('Edit Machine Group Name'),
    MachinesImnooDetails: i18n.t('Edit Machine Imnoo Name'),
    Devices: i18n.t(isPhone ? 'Add' : 'Add device'),
    Machines: i18n.t(isPhone ? 'Add' : 'Add machine'),
    Connector: i18n.t(isPhone ? 'Add' : 'Add device'),
    Company: i18n.t(isPhone ? 'Add' : 'Add device'),
    Support: i18n.t(isPhone ? 'Add' : 'Add device'),
  };

  return (
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginRight: scale(18) }}>
      <Button
        {...{
          variant: 'M',
          type: 'Primary',
          ...actionConfig,
          onPress: action,
        }}
      >
        <Text
          style={[
            font['Button 2'],
            {
              color: C('Label/Light/Selected'),
              textTransform: 'uppercase',
              ...actionConfig,
            },
          ]}
        >
          {tabMapping[name as keyof typeof tabMapping]}
        </Text>
      </Button>
    </View>
  );
};

export default HeaderActionButton;
